import React from 'react';

class Home extends React.Component{
    static STATE_STRUCT = () => {
        return {

        }
    };

    state = Home.STATE_STRUCT();

    render() {
        return (
            <div>
                Home
            </div>
        );
    }
}

export default Home;
